import * as alwaysInCacheTableIdList from './alwaysInCacheTableIdList';
import * as mruTableIdList from './mruTableIdList';
import updateAlwaysInCacheTableIds from './updateAlwaysInCacheTableIds';
import removeTableFromStore from '../../store-factory/removeTableFromStore';
import getSortByFolderId from 'owa-mail-folder-store/lib/selectors/getSortByFolderId';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import {
    subscribeToRowNotifications,
    unsubscribeToRowNotifications,
} from '../../notifications/rowNotificationsStrategy';
import {
    getViewFilterForTable,
    TableQueryType,
    MailFolderTableQuery,
    getInboxClassificationFilterForTable,
} from 'owa-mail-list-store';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

// MRU has the last 5 used folders
const MRU_TABLES_THRESHOLD: number = 5;

// Unsubscribe and remove all rows for this table from list view store
// Also remove the table from the store
function onRemoveTable(tableViewId: string) {
    unsubscribeToRowNotifications(tableViewId);
    removeTableFromStore(tableViewId);
}

export default function updateTablesInCache(tableView: TableView): number | undefined {
    if (tableView.tableQuery.type == TableQueryType.Search) {
        throw new Error('updateTablesInCache should never be called for Search table');
    }

    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;

    // Inbox with All filter
    if (
        tableView.tableQuery.folderId === folderNameToId('inbox') &&
        getViewFilterForTable(tableView) === 'All' &&
        isInboxFocusedOtherPivot(tableView)
    ) {
        // Checks the sort preferences of inbox
        const sortColumn = mailTableQuery.sortBy.sortColumn;
        const sortDirection = mailTableQuery.sortBy.sortDirection;
        const folderSettingsSortBy = getSortByFolderId(tableView.tableQuery.folderId);
        if (
            sortColumn === folderSettingsSortBy.sortColumn &&
            sortDirection === folderSettingsSortBy.sortDirection
        ) {
            return updateAlwaysInCacheTableIds();
        }
    }

    return mruTableIdList.update(tableView);
}

export function initializeTablesInCache() {
    alwaysInCacheTableIdList.initialize(subscribeToRowNotifications, onRemoveTable);
    updateAlwaysInCacheTableIds();
    mruTableIdList.initialize(subscribeToRowNotifications, onRemoveTable, MRU_TABLES_THRESHOLD);
}

export function canAddToMruTableIdList(): boolean {
    return mruTableIdList.canAddToList();
}

// VSO-18425 - refactor the table caching code as per the new design.
// This function should be just remove after the code refactoring
export function removeFromMruTableIdList(tableViewId: string) {
    mruTableIdList.remove(tableViewId);
}

function isInboxFocusedOtherPivot(tableView: TableView): boolean {
    const tableClassificationFilter = getInboxClassificationFilterForTable(tableView.id);
    return (
        tableClassificationFilter === InboxClassificationFilter.None ||
        tableClassificationFilter === InboxClassificationFilter.Focused ||
        tableClassificationFilter === InboxClassificationFilter.Other
    );
}
